import React from "react";
import { TableCell, TableRow } from "../../../design/table";
import { Income } from "../../../models/Income";

interface Props {
  income: Income;
}

const IncomeListItem: React.FC<Props> = ({ income }) => {
  return (
    <TableRow
      key={income._id}
      href={`/income/${income._id}`}
      className="transition-colors cursor-pointer hover:bg-gray-100"
    >
      <TableCell className="w-1/4">{income.amount}</TableCell>
    </TableRow>
  );
};

export default IncomeListItem;
